import React from "react";
import logo from "assets/logo.jpg";
import { Grid } from "@material-ui/core";

const Header = () => {
  return (
    <Grid container justify="center">
      <img src={logo} height="100" alt="logo"/>
    </Grid>
  );
};

export default Header;
